// @flow
import React from 'react'
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'go-transit',
  icon: [
    14,
    14,
    null,
    null,
    null,
    <g key="go-transit">
      <path d="M7,0C3.1,0,0,3.2,0,7c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7C14,3.2,10.9,0,7,0z M7,11.8c-2.7,0-4.8-2.2-4.8-4.8 S4.3,2.2,7,2.2s4.8,2.2,4.8,4.8S9.7,11.8,7,11.8z" />
      <path d="M7,4.2C5.4,4.2,4.2,5.5,4.2,7S5.4,9.8,7,9.8S9.8,8.6,9.8,7S8.6,4.2,7,4.2z" />
    </g>,
  ],
})
